import unescape from 'lodash/unescape';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import moment from 'moment';
import classNames from 'classnames';
import StorageUtils from '@spothero/utils/storage';
import DOMUtils from '@spothero/utils/dom';
import Button from '@spothero/ui/button';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import Tooltip from '@spothero/ui/tooltip';
import Icon from 'common/icon/Icon';
import DateUtils from 'utils/date';
import {getStore} from 'store/store';
import DestinationInfoModalMobile from 'destination/DestinationInfoModalMobile';
import {makeGetPriceRange} from 'filters/filters-selectors';
import SearchControlsModalMobile from './controls/SearchControlsModalMobile';
import SpotListFilters from './spot-list/SpotListFilters';
import {toggleFiltersView} from './search-actions';

class SearchDetailsMobile extends Component {
    static propTypes = {
        isBrowser: PropTypes.bool.isRequired,
        isMonthly: PropTypes.bool.isRequired,
        city: PropTypes.object.isRequired,
        destination: PropTypes.object,
        event: PropTypes.object,
        destinationHighPrice: PropTypes.number,
        starts: PropTypes.string.isRequired,
        ends: PropTypes.string,
        searchString: PropTypes.string,
        areFiltersVisible: PropTypes.bool,
        showSetTimesTooltip: PropTypes.bool,
        onFiltersToggle: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        const {
            isBrowser,
            isMonthly
        } = props;

        this.state = {
            showInfoModal: false,
            focusSearchInput: false,
            showSearchControlsModal: false,
            showTimeChangeProTip: (isBrowser)
                ? (!isMonthly && !StorageUtils.get('pro-tip-change-time') && !DOMUtils.el('.Tooltip'))
                : false,
        };
    }

    _onShowInfoModalClick = evt => {
        evt.preventDefault();
        evt.stopPropagation();

        this.setState({
            showInfoModal: true
        });
    }

    _onHideInfoModal = () => {
        this.setState({
            showInfoModal: false
        });
    }

    _onSearchDetailsClick = evt => {
        const inputClicked = (
            DOMUtils.hasClass(evt.target, 'SearchDetails-destination')
            || DOMUtils.hasClass(evt.target, 'SearchDetails-destination-text')
            || DOMUtils.hasClass(evt.target, 'icon-search')
        );

        this.setState({
            showSearchControlsModal: true,
            focusSearchInput: inputClicked,
            showTimeChangeProTip: false
        });

        StorageUtils.set('pro-tip-change-time', 1);
    }

    _onSearchClick = ({callback}) => {
        this.setState({
            showSearchControlsModal: false,
            focusSearchInput: false
        });

        if (callback) {
            callback();
        }
    }

    _onHideSearchControlsModal = () => {
        this.setState({
            showSearchControlsModal: false,
            focusSearchInput: false
        });
    }

    _onTimeChangeProTipHidden = () => {
        this.setState({
            showTimeChangeProTip: false
        });

        StorageUtils.set('pro-tip-change-time', 1);
    }

    openSearchControls = () => {
        this.setState({
            showSearchControlsModal: true,
            focusSearchInput: true
        });
    }

    render() {
        const {
            isMonthly,
            destination,
            city,
            event,
            searchString,
            areFiltersVisible,
            destinationHighPrice,
            starts,
            ends,
            showSetTimesTooltip,
            onFiltersToggle
        } = this.props;
        const {
            showInfoModal,
            showSearchControlsModal,
            focusSearchInput,
            showTimeChangeProTip
        } = this.state;
        const destinationTitle = (destination) ? destination.title : (city) ? city.display_name : false; // eslint-disable-line camelcase
        const startsMoment = moment(starts);
        let humanDateTimeStrings;
        let endsMoment;

        if (isMonthly) {
            endsMoment = startsMoment
                .clone()
                .add(1, 'month')
                .subtract(1, 'day');

            humanDateTimeStrings = DateUtils.getHumanDateTimesAsStrings({
                startDateTimeObj: startsMoment,
                isMonthly
            });
        } else {
            endsMoment = moment(ends);

            humanDateTimeStrings = DateUtils.getHumanDateTimesAsStrings({
                startDateTimeObj: startsMoment,
                endDateTimeObj: endsMoment
            });
        }
        const {
            startDate: humanStartDate,
            startTime: humanStartTime,
            endDate: humanEndDate,
            endTime: humanEndTime
        } = humanDateTimeStrings;
        const destinationClasses = classNames(
            'SearchDetails-destination',
            {'SearchDetails-destination-default': (!searchString && !destinationTitle)}
        );
        const searchTitle = (destinationTitle)
            ? unescape(destinationTitle)
            : (searchString)
                ? unescape(searchString)
                : 'Address, Landmark or Event';
        const searchTitleSuffix = `${(isMonthly) ? 'Monthly ' : ''}Parking`;

        return (
            <div
                className="SearchDetails"
                onClick={this._onSearchDetailsClick}
            >
                <span
                    className={destinationClasses}
                    itemType="http://schema.org/Place"
                >
                    <h1 className="SearchDetails-destination-text">{searchTitle} {searchTitleSuffix}</h1>
                    <meta
                        itemProp="name"
                        content={searchTitle}
                    />
                    <Icon name="search" />
                    <Button
                        onClick={this._onShowInfoModalClick}
                        className="SearchDetails-toggle-destination-info-button"
                    >
                        <Icon
                            name="info"
                            className="SearchDetails-toggle-destination-info"
                        />
                    </Button>
                </span>
                {!isMonthly &&
                    <div className="SearchDetails-current-datetime">
                        <div className="SearchDetails-current-datetime-start">
                            Start Time
                            <span className="SearchDetails-current-datetime-start-value">
                                {humanStartDate}, {humanStartTime}
                            </span>
                        </div>
                        <div className="SearchDetails-current-datetime-divider">
                            /
                        </div>
                        <div className="SearchDetails-current-datetime-end">
                            End Time
                            <span className="SearchDetails-current-datetime-end-value">
                                {humanEndDate}, {humanEndTime}
                            </span>
                        </div>
                    </div>
                }
                {isMonthly &&
                    <div className="SearchDetails-current-datetime SearchDetails-current-datetime-monthly">
                        <div className="SearchDetails-current-datetime-monthly-label">Month Begins</div>
                        <div className="SearchDetails-current-datetime-monthly-value">{humanStartDate}</div>
                    </div>
                }
                {showInfoModal &&
                    <DestinationInfoModalMobile
                        title={(destination)
                            ? (isMonthly)
                                ? `${destination.title} Monthly`
                                : destination.title
                            : (isMonthly)
                                ? `${city.display_name} Monthly`
                                : city.display_name
                        }
                        address={(destination) ? destination.street_address : null}
                        city={(destination) ? destination.city : city.display_name}
                        state={(destination) ? destination.state : city.state}
                        description={(destination)
                            ? (isMonthly && destination.monthly_description)
                                ? destination.monthly_description
                                : destination.description
                            : (isMonthly && city.monthly_description)
                                ? city.monthly_description
                                : city.description
                        }
                        event={event}
                        onHidden={this._onHideInfoModal}
                    />
                }
                {showSearchControlsModal &&
                    <SearchControlsModalMobile
                        focusSearchInput={focusSearchInput}
                        onHidden={this._onHideSearchControlsModal}
                        onSearchClick={this._onSearchClick}
                        onClosePanelClick={this._onHideSearchControlsModal}
                    />
                }
                {(showTimeChangeProTip && !showSearchControlsModal && !showInfoModal && showSetTimesTooltip) &&
                    <Tooltip
                        containerClassName="SearchDetailsTooltip-set-times"
                        position="bottom"
                        triggerSelector=".SearchDetails-current-datetime"
                        updateOnMove
                        onHidden={this._onTimeChangeProTipHidden}
                    >
                        Press here to set your times so we can guarantee your reservation.
                    </Tooltip>
                }
                {(areFiltersVisible) &&
                    <Modal
                        title="Filter Spots"
                        className="searchFiltersModal"
                        store={getStore()}
                        onCloseClick={onFiltersToggle}
                    >
                        <ModalContent>
                            <SpotListFilters
                                highestPrice={destinationHighPrice}
                            />
                        </ModalContent>
                    </Modal>
                }
            </div>
        );
    }
}

const makeMapStateToProps = () => {
    const getPriceRange = makeGetPriceRange();
    const mapStateToProps = state => {
        const {
            search: {
                data: {
                    searchType,
                    areFiltersVisible
                }
            },
            searchRequest: {
                monthly,
                starts,
                ends,
                search_string: searchString
            },
            city: {
                data: city
            },
            destination: {
                data: destination
            },
            event: {
                data: event
            }
        } = state;

        const {
            priceLow,
            priceHigh
        } = getPriceRange(state);

        return {
            isMonthly: monthly,
            searchString,
            destinationLowPrice: priceLow,
            destinationHighPrice: priceHigh,
            starts,
            ends,
            searchType,
            city,
            destination,
            event,
            areFiltersVisible
        };
    };

    return mapStateToProps;
};

const mapDispatchToProps = {
    onFiltersToggle: toggleFiltersView
};

export default connect(makeMapStateToProps, mapDispatchToProps, null, {forwardRef: true})(SearchDetailsMobile);
